import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-alert-page-ui',
    templateUrl: './bb-alert-page-ui.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AlertPageComponent {
  onAlertClosed() {
    console.log('the alert was closed');
  }
}
